import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { FileText, Download, Calendar, DollarSign, User, Printer } from "lucide-react";

export default function Payslip() {
  const { team, mode, currentUserId, expenses, loans: ctxLoans } = useApp();
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const months = [];
  for (let i = 0; i < 12; i++) {
    const d = new Date();
    d.setMonth(d.getMonth() - i);
    months.push(d.toISOString().slice(0, 7));
  }

  const employees = (team || []).filter(m => m.role === "employee" || m.salary);

  const getPayslipData = (emp) => {
    if (!emp) return null;
    const salary = parseFloat(emp.salary) || 0;
    const [year, month] = selectedMonth.split("-").map(Number);

    // Get approved loans for this employee
        const loans = ctxLoans || [];
      const empLoans = loans.filter(l =>
      l.status === "Approved" &&
      !l.repaid &&
      (l.employeeCode === emp.code || l.employeeCode === emp.employeeCode || l.employeeName === emp.name)
    );
    const totalLoan = empLoans.reduce((s, l) => s + (parseFloat(l.amount) || 0), 0);

    // Get employee expenses for the month
    const empExpenses = (expenses || []).filter(e => {
      const ed = new Date(e.date);
      return ed.getMonth() + 1 === month && ed.getFullYear() === year &&
        (e.addedBy === emp.name || e.owner === emp.name);
    });
    const totalExpenseReimbursement = empExpenses.filter(e => e.category === "Reimbursement").reduce((s, e) => s + (parseFloat(e.amount) || 0), 0);

    const basicPay = salary;
                        const totalDeductions = totalLoan;
    const netPay = salary - totalDeductions + totalExpenseReimbursement;

    return {
      employee: emp,
      month: selectedMonth,
      monthName: new Date(year, month - 1).toLocaleString("default", { month: "long", year: "numeric" }),
      earnings: {
        basicPay: Math.round(basicPay),
                                reimbursement: Math.round(totalExpenseReimbursement),
        totalEarnings: Math.round(salary + totalExpenseReimbursement)
      },
      deductions: {
                        loanDeduction: Math.round(totalLoan),
        totalDeductions: Math.round(totalDeductions)
      },
      netPay: Math.round(netPay),
      grossSalary: salary
    };
  };

  const generatePDF = (data) => {
    if (!data) return;
    const w = window.open("", "_blank", "width=800,height=900");
    w.document.write(`<!DOCTYPE html><html><head><title>Payslip - ${data.employee.name}</title>
    <style>
      body { font-family: 'Segoe UI', sans-serif; padding: 40px; background: #fff; color: #1a1a2e; margin: 0; }
      .header { text-align: center; border-bottom: 3px solid #F5A623; padding-bottom: 20px; margin-bottom: 30px; }
      .header h1 { color: #F5A623; margin: 0; font-size: 28px; }
      .header p { color: #666; margin: 4px 0; font-size: 13px; }
      .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 30px; padding: 20px; background: #f8f9fa; border-radius: 10px; }
      .info-item { font-size: 13px; }
      .info-label { color: #666; font-size: 11px; text-transform: uppercase; letter-spacing: 1px; }
      .info-value { font-weight: 700; color: #1a1a2e; font-size: 14px; }
      table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
      th { background: #1a1a2e; color: #fff; padding: 12px 16px; text-align: left; font-size: 13px; }
      td { padding: 10px 16px; border-bottom: 1px solid #e2e8f0; font-size: 13px; }
      .total-row { background: #f0f9ff; font-weight: 700; }
      .net-pay { text-align: center; padding: 24px; background: linear-gradient(135deg, #F5A623, #E8960F); border-radius: 12px; margin: 30px 0; }
      .net-pay h2 { margin: 0; color: #000; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; }
      .net-pay .amount { font-size: 36px; font-weight: 900; color: #000; margin: 8px 0 0; }
      .footer { text-align: center; margin-top: 40px; padding-top: 20px; border-top: 1px solid #e2e8f0; font-size: 11px; color: #999; }
      @media print { body { padding: 20px; } }
    </style></head><body>
    <div class="header">
      <h1>FinBoard</h1>
      <p>Stake Affiliate Financial Command Center</p>
      <p style="font-size:16px;font-weight:700;margin-top:12px;">PAYSLIP — ${data.monthName}</p>
    </div>
    <div class="info-grid">
      <div class="info-item"><div class="info-label">Employee Name</div><div class="info-value">${data.employee.name}</div></div>
      <div class="info-item"><div class="info-label">Employee Code</div><div class="info-value">${data.employee.code || data.employee.employeeCode || "N/A"}</div></div>
      <div class="info-item"><div class="info-label">Department</div><div class="info-value">${data.employee.department || data.employee.role || "General"}</div></div>
      <div class="info-item"><div class="info-label">Pay Period</div><div class="info-value">${data.monthName}</div></div>
    </div>
    <table>
      <tr><th colspan="2">Earnings</th></tr>
      <tr><td>Basic Pay</td><td style="text-align:right">₹${data.earnings.basicPay.toLocaleString()}</td></tr>
                        ${data.earnings.reimbursement > 0 ? `<tr><td>Expense Reimbursement</td><td style="text-align:right">₹${data.earnings.reimbursement.toLocaleString()}</td></tr>` : ""}
      <tr class="total-row"><td><strong>Total Earnings</strong></td><td style="text-align:right"><strong>₹${data.earnings.totalEarnings.toLocaleString()}</strong></td></tr>
    </table>
    <table>
      <tr><th colspan="2">Deductions</th></tr>
                  ${data.deductions.loanDeduction > 0 ? `<tr><td>Loan Deduction</td><td style="text-align:right">₹${data.deductions.loanDeduction.toLocaleString()}</td></tr>` : ""}
      <tr class="total-row"><td><strong>Total Deductions</strong></td><td style="text-align:right"><strong>₹${data.deductions.totalDeductions.toLocaleString()}</strong></td></tr>
    </table>
    <div class="net-pay">
      <h2>Net Pay</h2>
      <div class="amount">₹${data.netPay.toLocaleString()}</div>
    </div>
    <div class="footer">
      <p>This is a system-generated payslip from FinBoard v11.3</p>
      <p>Generated on ${new Date().toLocaleDateString()}</p>
    </div>
    <script>setTimeout(()=>window.print(),500);</script>
    </body></html>`);
  };

  const currentEmp = mode === "employee" ? employees.find(e =>
    e.id === currentUserId || e.code === currentUserId || e.employeeCode === currentUserId || e.name === currentUserId
  ) : null;

  const displayEmp = mode === "admin" ? employees.find(e => e.id === selectedEmployee || e.code === selectedEmployee || e.name === selectedEmployee) : currentEmp;
  const payslipData = displayEmp ? getPayslipData(displayEmp) : null;

  const cardStyle = { padding: 24, borderRadius: 16, background: "rgba(15,23,42,.6)", border: "1px solid rgba(100,116,139,.15)", marginBottom: 20 };

  return (
    <div style={{ padding: "24px 32px", maxWidth: 900, margin: "0 auto" }}>
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: "#E2E8F0", margin: 0 }}>
          <FileText size={22} style={{ verticalAlign: "middle", marginRight: 10, color: "#F5A623" }} />
          Payslip Generator
        </h2>
        <p style={{ color: "#64748B", fontSize: 13, margin: "4px 0 0" }}>
          {mode === "admin" ? "Admin > Payslip" : "Employee > My Payslip"}
        </p>
      </div>

      {/* Controls */}
      <div style={cardStyle}>
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ flex: 1, minWidth: 200 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748B", textTransform: "uppercase", letterSpacing: 1, display: "block", marginBottom: 6 }}>
              <Calendar size={12} style={{ verticalAlign: "middle", marginRight: 4 }} /> Select Month
            </label>
            <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1px solid rgba(100,116,139,.25)", background: "rgba(15,23,42,.8)", color: "#E2E8F0", fontSize: 14, outline: "none" }}>
              {months.map(m => (
                <option key={m} value={m}>{new Date(m + "-01").toLocaleString("default", { month: "long", year: "numeric" })}</option>
              ))}
            </select>
          </div>

          {mode === "admin" && (
            <div style={{ flex: 1, minWidth: 200 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#64748B", textTransform: "uppercase", letterSpacing: 1, display: "block", marginBottom: 6 }}>
                <User size={12} style={{ verticalAlign: "middle", marginRight: 4 }} /> Select Employee
              </label>
              <select value={selectedEmployee} onChange={e => setSelectedEmployee(e.target.value)} style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1px solid rgba(100,116,139,.25)", background: "rgba(15,23,42,.8)", color: "#E2E8F0", fontSize: 14, outline: "none" }}>
                <option value="">Choose employee...</option>
                {employees.map(emp => (
                  <option key={emp.id || emp.code || emp.name} value={emp.id || emp.code || emp.name}>{emp.name} ({emp.code || emp.employeeCode || "N/A"})</option>
                ))}
              </select>
            </div>
          )}

          {payslipData && (
            <button onClick={() => generatePDF(payslipData)} style={{ padding: "10px 24px", borderRadius: 10, border: "none", background: "linear-gradient(135deg,#F5A623,#E8960F)", color: "#000", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, height: 42 }}>
              <Download size={16} /> Download Payslip
            </button>
          )}
        </div>
      </div>

      {/* Payslip Preview */}
      {payslipData ? (
        <div style={cardStyle}>
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <h3 style={{ color: "#F5A623", fontSize: 20, fontWeight: 800, margin: 0 }}>FinBoard Payslip</h3>
            <p style={{ color: "#64748B", fontSize: 13, margin: "4px 0 0" }}>{payslipData.monthName}</p>
          </div>

          {/* Employee Info */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 24, padding: 16, borderRadius: 10, background: "rgba(245,166,35,.04)", border: "1px solid rgba(245,166,35,.1)" }}>
            <div><span style={{ fontSize: 11, color: "#64748B" }}>Name</span><div style={{ fontWeight: 700, color: "#E2E8F0", fontSize: 14 }}>{payslipData.employee.name}</div></div>
            <div><span style={{ fontSize: 11, color: "#64748B" }}>Code</span><div style={{ fontWeight: 700, color: "#E2E8F0", fontSize: 14 }}>{payslipData.employee.code || payslipData.employee.employeeCode || "N/A"}</div></div>
            <div><span style={{ fontSize: 11, color: "#64748B" }}>Department</span><div style={{ fontWeight: 700, color: "#E2E8F0", fontSize: 14 }}>{payslipData.employee.department || payslipData.employee.role || "General"}</div></div>
            <div><span style={{ fontSize: 11, color: "#64748B" }}>Gross Salary</span><div style={{ fontWeight: 700, color: "#E2E8F0", fontSize: 14 }}>₹{payslipData.grossSalary.toLocaleString()}</div></div>
          </div>

          {/* Earnings */}
          <div style={{ marginBottom: 20 }}>
            <h4 style={{ fontSize: 13, fontWeight: 700, color: "#10B981", marginBottom: 12, textTransform: "uppercase", letterSpacing: 1 }}>Earnings</h4>
            {[
              ["Basic Pay", payslipData.earnings.basicPay],
                                                        ...(payslipData.earnings.reimbursement > 0 ? [["Reimbursement", payslipData.earnings.reimbursement]] : [])
            ].map(([label, amt]) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid rgba(100,116,139,.1)", fontSize: 13 }}>
                <span style={{ color: "#94A3B8" }}>{label}</span>
                <span style={{ color: "#E2E8F0", fontWeight: 600 }}>₹{amt.toLocaleString()}</span>
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", fontSize: 14, fontWeight: 700 }}>
              <span style={{ color: "#10B981" }}>Total Earnings</span>
              <span style={{ color: "#10B981" }}>₹{payslipData.earnings.totalEarnings.toLocaleString()}</span>
            </div>
          </div>

          {/* Deductions */}
          <div style={{ marginBottom: 20 }}>
            <h4 style={{ fontSize: 13, fontWeight: 700, color: "#EF4444", marginBottom: 12, textTransform: "uppercase", letterSpacing: 1 }}>Deductions</h4>
            {[
                                          ...(payslipData.deductions.loanDeduction > 0 ? [["Loan Deduction", payslipData.deductions.loanDeduction]] : [])
            ].map(([label, amt]) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid rgba(100,116,139,.1)", fontSize: 13 }}>
                <span style={{ color: "#94A3B8" }}>{label}</span>
                <span style={{ color: "#E2E8F0", fontWeight: 600 }}>₹{amt.toLocaleString()}</span>
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", fontSize: 14, fontWeight: 700 }}>
              <span style={{ color: "#EF4444" }}>Total Deductions</span>
              <span style={{ color: "#EF4444" }}>₹{payslipData.deductions.totalDeductions.toLocaleString()}</span>
            </div>
          </div>

          {/* Net Pay */}
          <div style={{ textAlign: "center", padding: 24, borderRadius: 14, background: "linear-gradient(135deg,rgba(245,166,35,.1),rgba(245,166,35,.05))", border: "2px solid rgba(245,166,35,.2)" }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#94A3B8", textTransform: "uppercase", letterSpacing: 1 }}>Net Pay</div>
            <div style={{ fontSize: 36, fontWeight: 900, color: "#F5A623", marginTop: 4 }}>₹{payslipData.netPay.toLocaleString()}</div>
          </div>
        </div>
      ) : (
        <div style={{ ...cardStyle, textAlign: "center", padding: 60 }}>
          <DollarSign size={48} style={{ color: "#334155", marginBottom: 16 }} />
          <div style={{ color: "#64748B", fontSize: 15 }}>{mode === "admin" ? "Select an employee to generate payslip" : "No payslip data found"}</div>
        </div>
      )}
    </div>
  );
}
